import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DocumentEditor } from "./DocumentEditor";
import { DocHistory } from "./DocHistory";

export function DocumentPanel({ path, id, onDeleted }) {
  return (
    <Tabs defaultValue="fields" data-testid="document-panel">
      <TabsList className="mb-3">
        <TabsTrigger value="fields" data-testid="doc-tab-fields">Fields</TabsTrigger>
        <TabsTrigger value="history" data-testid="doc-tab-history">History</TabsTrigger>
      </TabsList>
      <TabsContent value="fields"><DocumentEditor path={path} id={id} onDeleted={onDeleted} /></TabsContent>
      <TabsContent value="history"><DocHistory path={path} id={id} /></TabsContent>
    </Tabs>
  );
}
